import { render, staticRenderFns } from "./ModalAlertConflict.vue?vue&type=template&id=8c90aa7c&scoped=true&"
import script from "./ModalAlertConflict.vue?vue&type=script&lang=js&"
export * from "./ModalAlertConflict.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertConflict.vue?vue&type=style&index=0&id=8c90aa7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90aa7c",
  null
  
)

export default component.exports